<template>
  <svg
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11ZM12 7C12 6.44772 11.5523 6 11 6C10.4477 6 10 6.44772 10 7V11C10 11.5523 10.4477 12 11 12C11.5523 12 12 11.5523 12 11V7ZM11 14C10.4477 14 10 14.4477 10 15C10 15.5523 10.4477 16 11 16H11.01C11.5623 16 12.01 15.5523 12.01 15C12.01 14.4477 11.5623 14 11.01 14H11Z"
    />
  </svg>
</template>
